"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonException = void 0;
exports.RegisterException = RegisterException;
/**
 * Декаратор что бы регистрировать эксепшены
 */
function RegisterException(type) {
    return function (target) {
        CommonException.register(target, type);
    };
}
/**
 * Основной класс ошибок от которого наследуются остальные классы ошибок
 */
class CommonException extends Error {
    constructor(input = {}) {
        var _a, _b;
        super((_a = input.message) !== null && _a !== void 0 ? _a : 'Common exception', { cause: input.cause });
        this.name = this.constructor.name;
        this.type = (_b = input.type) !== null && _b !== void 0 ? _b : 'CommonException';
        this.payload = input.payload;
        this.debugPayload = input.debugPayload;
        this.transportPayload = input.transportPayload;
    }
    /**
     * Добавляет ошибки в локальный регистер что бы потом делать по ним поиск
     */
    static register(cls, type) {
        var _a, _b;
        let instance;
        try {
            instance = new cls();
        }
        catch (error) {
            throw Error(`В классе ${cls.name} конструктор обязательно принимает ` +
                'аргументы. Конструкторы exceptions должны быть необязательны!', { cause: error });
        }
        const previousClass = this.registry.all.get(instance.type);
        if (previousClass) {
            throw Error(`В в классах exceptions ${instance.name} и ${previousClass.name} ` +
                `указаны одинаковые type: ${instance.type}`);
        }
        this.registry.all.set(instance.type, cls);
        if (type === 'baseHttp') {
            if (!((_a = instance.transportPayload) === null || _a === void 0 ? void 0 : _a.httpStatus)) {
                throw Error(`В декораторе RegisterException на классе ${instance.name} ` +
                    'указан тип baseHttp, но в самом классе httpStatus не указан');
            }
            const previousBaseHttpClass = this.registry.baseHttp.get(instance.transportPayload.httpStatus);
            if (previousBaseHttpClass) {
                throw Error(`В классах ${instance.name} и ${previousBaseHttpClass.name} ` +
                    'установленые одинаковые коды http ошибок. В декораторе ' +
                    'RegisterException на обоих классах указан тип baseHttp.');
            }
            this.registry.baseHttp.set((_b = instance.transportPayload) === null || _b === void 0 ? void 0 : _b.httpStatus, cls);
        }
        if (type === 'sue') {
            const previousSueClass = this.registry.sue.get(instance.type);
            if (previousSueClass) {
                throw Error(`В классах exceptions ${instance.name} и ` +
                    `${previousSueClass.name} указаны одинаковые ` +
                    `type: ${instance.type}`);
            }
            this.registry.sue.set(instance.type, cls);
        }
    }
    /**
     * Делает поиск по ошибкам и возвращает класс ошибки
     */
    static find(type) {
        var _a;
        return (_a = this.registry.all.get(type)) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Делает поиск по базовым http ошибкам и возвращает класс ошибки
     */
    static findBaseHttp(httpStatus) {
        var _a;
        return (_a = this.registry.baseHttp.get(httpStatus)) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Делает поиск по common sue ошибкам и возвращает класс ошибки
     */
    static findSue(type) {
        var _a;
        return (_a = this.registry.sue.get(type)) !== null && _a !== void 0 ? _a : null;
    }
    setMessage(message) {
        this.message = message;
        return this;
    }
    setPayload(payload) {
        this.payload = payload;
        return this;
    }
    setDebugPayload(debugPayload) {
        this.debugPayload = debugPayload;
        return this;
    }
    setTransportPayload(transportPayload) {
        this.transportPayload = transportPayload;
        return this;
    }
}
exports.CommonException = CommonException;
CommonException.registry = {
    all: new Map(),
    baseHttp: new Map(),
    sue: new Map()
};
//# sourceMappingURL=common.exception.js.map